import React, { useCallback } from 'react';
import { ISigningAppointmentEditFormData } from '../../../../../../types/signingAppointment/ISigningAppointmentEditFormData';
import { TopLevelSummary } from './TopLevelSummary';
import { SignatoriesList } from './SignatoriesList';
import { AppointmentNotes } from './AppointmentNotes';
import { AppointmentNotary } from './AppointmentNotary';
import { UUID } from 'types/shared/UUID';
import { DigitalScheduling } from './DigitalScheduling';
import { checkForMutationSuccess } from '../../../../../../API/checkForMutationSuccess';
import { useParams } from 'react-router-dom';
import { useUpdateMutation } from '../../../../../../API/order/signingAppointment/SigningAppointmentAPI';

export interface IAppointmentDetailsTabProps {
  onAddEventClick: (appointmentId?: UUID) => void;
}

const iconClassNames = 'mr-1 h-5 w-5';

export const AppointmentDetailsTab: React.FC<IAppointmentDetailsTabProps> = ({ onAddEventClick }) => {
  const { orderId, appointmentId } = useParams<{ orderId: UUID; appointmentId: UUID }>();
  const [updateSigningAppointment] = useUpdateMutation();

  const onSaveEditions = useCallback(
    async (data: ISigningAppointmentEditFormData) => {
      const updateResponse = await updateSigningAppointment({
        id: appointmentId,
        orderId,
        data,
      });
      checkForMutationSuccess(updateResponse, 'updating signing appointment');
    },
    [updateSigningAppointment, orderId, appointmentId]
  );
  return (
    <div className={'flex-col space-y-4'}>
      <TopLevelSummary onAddEventClick={onAddEventClick} iconClassNames={iconClassNames} />
      <SignatoriesList onSaveEditions={onSaveEditions} />
      <AppointmentNotes onSaveEditions={onSaveEditions} iconClassNames={iconClassNames} />
      <AppointmentNotary onSaveEditions={onSaveEditions} iconClassNames={iconClassNames} />
      <DigitalScheduling />
    </div>
  );
};
